import { Tab, Tabs } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

const workspaceTabs = [
  { label: "Members", path: "/workspace/members" },
  { label: "Settings", path: "/workspace/settings" },
  { label: "Cameras", path: "/workspace/cameras" },
];

// Sub-navigation shared by workspace admin pages.
const WorkspaceTabs = () => {
  const { pathname } = useLocation();
  const index = workspaceTabs.findIndex((t) => pathname.startsWith(t.path));

  return (
    <Tabs
      value={index === -1 ? 0 : index}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{
        borderBottom: 1,
        borderColor: "divider",
        mb: { xs: 1.5, sm: 2 },
        "& .MuiTab-root": {
          minWidth: { xs: 80, sm: 120 },
          fontSize: { xs: "0.85rem", sm: "0.95rem" },
          px: { xs: 1.5, sm: 2.5 },
        },
      }}
    >
      {workspaceTabs.map((t) => (
        <Tab key={t.path} label={t.label} component={Link} to={t.path} />
      ))}
    </Tabs>
  );
};


export default WorkspaceTabs;
